import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Header from './layouts/header';
import Footer from './layouts/footer';
import ScrollManager from './components/ScrollManager';
import PageLoader from './components/ui/PageLoader';

// The landing page is the entry point for virtually all traffic, so it stays in
// the main bundle. Every secondary route is split out and fetched on demand.
import LandingPage from './pages/LandingPage';

const Season = lazy(() => import('./pages/season/season'));
const OrderSuccess = lazy(() => import('./pages/orderSuccess'));
const Blog = lazy(() => import('./pages/blog'));
const BlogDetail = lazy(() => import('./components/blogDetail'));
const Terms = lazy(() => import('./pages/legal/Terms'));
const Privacy = lazy(() => import('./pages/legal/Privacy'));
const Refund = lazy(() => import('./pages/legal/Refund'));
const NotFound = lazy(() => import('./pages/NotFound'));

function App() {
  return (
    <Router>
      <ScrollManager />
      <Header />

      <main id="contenu-principal">
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/nouvelle-saison" element={<Season />} />
            {/* Legacy World Cup path: kept alive so existing ad links and
                bookmarks land on the current campaign instead of a 404. */}
            <Route path="/wc" element={<Season />} />
            <Route path="/commande-confirmee" element={<OrderSuccess />} />
            <Route path="/paiement-reussi" element={<OrderSuccess />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>

      <Footer />
    </Router>
  );
}

export default App;
